/**
 * AboutSection.tsx
 * ─────────────────
 * Section "Juristes & ingénieurs. Ensemble."
 * Fond sombre (#1c2333), layout 2 colonnes : texte gauche, logo animé droite.
 *
 * Usage :
 *   <AboutSection />
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TAGS = ['lawyers', 'data', 'genai', 'paris'] as const;

export const AboutSection = () => {
  const { t } = useTranslation();
  return (
  <section
    className="py-20 relative overflow-hidden"
    style={{ background: '#1c2333' }}
  >
    {/* Watermark logo géant bas-droite */}
    <div
      className="absolute right-[-60px] top-1/2 -translate-y-1/2 pointer-events-none select-none opacity-[0.07]"
      style={{ width: '440px', height: '440px' }}
      aria-hidden="true"
    >
      <img
        src="/public/smartlawyer_animated.svg"
        alt=""
        className="w-full h-full object-contain"
      />
    </div>

    <div className="max-w-[1100px] mx-auto px-6 sm:px-8 relative z-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

        {/* ── Colonne gauche : texte ── */}
        <div>
          <span className="block text-[10px] font-bold uppercase tracking-[.14em] text-white/40 mb-2.5">
            {t('about.eyebrow')}
          </span>
          <h2 className="font-serif text-[30px] sm:text-[34px] font-bold text-white tracking-[-0.03em] leading-[1.2] mb-4">
            {t('about.title_start')}<br />
            <em className="not-italic" style={{ color: '#b8ccff' }}>{t('about.title_highlight')}</em>
          </h2>
          <p className="text-[14px] text-white/60 leading-[1.75] mb-4">
            {t('about.p1')}
          </p>
          <p className="text-[14px] text-white/60 leading-[1.75] mb-6">
            {t('about.p2')}
          </p>

          {/* Tags */}
          <div className="flex flex-wrap gap-2 mb-8">
            {TAGS.map(tag => (
              <span
                key={tag}
                className="text-[11px] font-medium px-3 py-1 rounded-full border border-white/15 text-white/60"
              >
                {t(`about.tags.${tag}`)}
              </span>
            ))}
          </div>

          <Link
            to="/qui-sommes-nous"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-[10px] text-white text-[13px] font-semibold border border-white/20 hover:bg-white/10 transition-colors"
          >
            {t('about.learn_more')}
          </Link>
        </div>

        {/* ── Colonne droite : logo animé ── */}
        <div className="flex items-center justify-center">
          <img
            src="/public/smartlawyer_animated.svg"
            alt="SmartLawyer Legal Graph"
            className="w-[260px] h-[260px] object-contain"
            style={{ opacity: 0.9 }}
          />
        </div>

      </div>
    </div>
  </section>
  );
};